// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nqIq","title":"styles_title__XCk2z"};